module.exports = __webpack_public_path__ + "img/default_image_banner.f8bd7680.png";